<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
import { withDefaults, defineProps, defineEmits } from 'vue';

import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const emits = defineEmits(['posChange', 'valueChange']);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1199.887 1686.952">
  <g id="fengmian4" transform="translate(8.385 2.952)">
    <path d="M16352.5,5853.607V5218.5h-7.884V4711h907.365l-640.926,814.919L16352.5,5853.607Z" transform="translate(-16353 -4711)" fill="#0f0f0f"/>
    <path d="M-14924.254-10525.763h228.223l439.748-543.189h-235.172Z" transform="translate(15270 11066)" fill="var(--theme-color-1)"/>
    <path d="M15798.295,6074H15481l596-769.1v424.842L15798.295,6074Z" transform="translate(-14885.501 -4390)" fill="var(--theme-color-1)"/>
    <path d="M15742,6046h-261l261-327.574V6046Z" transform="translate(-14550.5 -4475)" fill="#0f0f0f"/>
  </g>
</svg>
`;

const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
  overflow: hidden;
}
.svg {
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  position: absolute;
  left: -10px;
  top: -10px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  font-weight: 600;
}
.project-name,
.time {
  max-width: 690px;
  font-size: 63px;
  color: #404040;
}

.project-name {
  min-width: 690px;
}
.time {
  font-size: 36px;
  min-width: 250px;
  //text-align: center;
}
.enterprise-name {
  font-size: 32px;
  text-align: center;
  width: 450px;
  color: #fff;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
